// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"b5edf86e","488":"fb420d7f","584":"0dcb3b78","585":"648521d3","648":"57500bb1","946":"25ebe31a"}[chunkId] + ".chunk.js";
};